module.exports = __webpack_public_path__ + "static/media/other-on-hover.2137d9cb.png";